/// <reference path="../walkinManagerKiosk.module.ts" />
/// <reference path="../../../../../typings/index.d.ts" />
/// <reference path="../../../../../src/app/components/common/common.module.ts" />


module Meevo.Plugins.WalkinManagerKiosk.ExitKiosk {

    import KioskModeLogic = Meevo.Components.Common.KioskModeLogic;
    declare var screenfull: any;

    class ExitKioskController {
        loginStatus: string;
        userName: string;
        password: string;

        static $inject = [
            '$rootScope',
            '$scope',
            '$mdDialog',
            'meevo.components.modal.ModalService',
            '$http',
            '$translate',
            "meevo.components.common.DataService",
            "meevo.components.common.IdentityService",
            'isKiosk',
            'meevo.components.common.KioskModeLogic',
        ];

        public model: any;
        public userForm: any;
        public exitLabel: string = 'Kiosk';
        private oneTry: boolean;

        constructor(
            protected $rootScope: ng.IRootScopeService,
            protected $scope: ng.IScope,
            protected $mdDialog: ng.material.IDialogService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected $http: angular.IHttpService,
            protected $translate: angular.translate.ITranslateService,
            private dataService: Meevo.Components.Common.ICommonDataService,
            private identityService: Meevo.Components.Common.IdentityService,
            isKiosk: any,
            private _kioskModeLogic: KioskModeLogic
        ) {
            this.exitLabel = <boolean>isKiosk ? 'Kiosk' : 'Display';
        };

        public exit(): void {
            let uri = '/api/Security/AppAuth';

            this.loginStatus = '';

            let account = {
                username: this.userName,
                password: this.password
            };
            // TODO: implement KioskModeComponent instead of this
            this.dataService.customMethodData('api/Auth/ValidateCredentials', 'POST', {
                userName: this.userName,
                password: this.password
            }).then(({ data }) => {
                if (data) {
                    if (this.identityService.current().userName === this.userName) {
                        this.$rootScope.$broadcast(Meevo.Components.Common.Messages.REFRESH_IDENTITY, true);
                        this.$rootScope.$broadcast(Meevo.Components.Common.Messages.FORCE_SESSION_RELOAD);
                        if (!navigator.userAgent.match(/iPhone|iPad|iPod/i)) {
                            screenfull.exit();
                        }
                        this.$mdDialog.hide(false);
                    } else {
                        this._kioskModeLogic.loginNewUser(this.userName, this.password).then(() => {
                            window.location.reload();
                        });
                    }
                } else {
                    this.loginStatus = this.$translate.instant('LABEL_INVALID_AUTHENTICATION');
                }
            });
        }

        public closeModal(): void {
            this.$mdDialog.cancel();
        };
    }

    angular.module('meevo.plugins.walkinManagerKiosk')
        .controller('meevo.plugins.walkinManagerKiosk.exitKiosk.ExitKioskController', ExitKioskController);
}
